export const getPrefix = (className: string) => {
  return 'landing-v2-custom-' + className;
};
